module.exports = __webpack_public_path__ + "img/zngg.d452d6ca.png";